import '../../../styles/Blog.css';
import { decode } from "html-entities";

type blogParagraph = {
    paragraph: string;
}

function BlogParagraph(props: blogParagraph) {
    return (
        <div className="blog-paragraph-block">
            <div
                dangerouslySetInnerHTML={{
                    __html: decode(decode(props.paragraph || ""))
                }}
            />
        </div>
    )
}
export default BlogParagraph;
